import Card from "./Card"

class Deck {
    constructor({ cards }) {
        this.cards = cards || []
    }

    find(id) {
        return this.cards.find(card => card.id === id)
    }

    draw( number = 1 ) {
        const drawnCards = this.cards.slice(-number).map(card => new Card({...card}))
        const newDeck = new Deck({ cards: this.cards.slice(0, -number).map(card => new Card({...card})) })
        return [ drawnCards, newDeck ]
    }

    shuffle( card ) {
        const newCards = this.cards.map(card => new Card({...card}))
        if ( card ) {
            newCards.push(new Card({...card}))
        }
        const shuffledCards = newCards.sort(() => Math.random() - 0.5)
        return new Deck({ cards: shuffledCards })
    }

    get length() {
        return this.cards.length
    }
}

export default Deck